var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component } from 'vue-property-decorator';
import GlobalVue from "../../globalVue";
import OrderImportTemplateService from '../../api/OrderImportTemplateService';
import { Loading } from 'element-ui';
import HeaderItem from "../../components/HeaderItem";
var Edit = (function (_super) {
    __extends(Edit, _super);
    function Edit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            template_name: '',
            sort: ''
        };
        _this.listData = [];
        _this.importDataList = [];
        _this.template_url = "";
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.templateId = '';
        return _this;
    }
    Edit.prototype.created = function () {
        this.service = OrderImportTemplateService.getInstance();
    };
    Edit.prototype.mounted = function () {
        this.getDetail();
    };
    Edit.prototype.getDetail = function () {
        var _this = this;
        this.service.getDetail({
            template_id: this.templateId
        }).then(function (res) {
            if (res.data && res.data.success) {
                var data = res.data.data;
                _this.formData.template_name = data.template_name;
                _this.formData.sort = data.sort;
                _this.template_url = data.template_url;
                _this.importDataList = data.table_header_item;
                _this.listData = data.table_header;
            }
        });
    };
    Edit.prototype.save = function () {
        var _this = this;
        if (!this.formData.template_name) {
            return this.$message.error('请填写模板名称');
        }
        var data = {
            template_id: this.templateId,
            template_name: this.formData.template_name,
            sort: this.formData.sort,
            template_url: this.template_url,
            table_header_item: this.importDataList,
            table_header: this.listData
        };
        var params = {
            data: JSON.stringify(data)
        };
        this.service.updatePoo(params).then(function (res) {
            if (res.data && res.data.success) {
                _this.$message.success(res.data.msg || '编辑模板成功');
                setTimeout(function () {
                    GlobalVue.$emit("closeTab", _this);
                    if (_this.opener) {
                        _this.opener.getList();
                    }
                }, 1000);
            }
            else {
                _this.$message.error(res.data.msg || '编辑模板失败');
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    Edit.prototype.befordUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "xlsx" || fileType == "xls"))) {
            this.$message.error("文件只能是xlsx或xls");
            return false;
        }
        ;
        if (!this.loadingInstance)
            this.loadingInstance = Loading.service({ fullscreen: true });
    };
    Edit.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            var data = response.data;
            this.importDataList = data.table_header_item;
            this.template_url = data.full_path;
            this.listData.forEach(function (item) {
                item.alias_name = '';
            });
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    Edit.prototype.uploadError = function (err, file, fileList) {
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    Edit.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
        }
        else {
        }
        this.loadingInstance.close();
    };
    Edit.prototype.uploadProgress = function (event, file, fileList) {
    };
    Edit = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
        })
    ], Edit);
    return Edit;
}(Vue));
export default Edit;
